$(function(){
});

var map;
function initMap() {
 var geocoder = new google.maps.Geocoder();
 var map = new google.maps.Map(document.getElementById('map'), {
  center: {lat: 36.112311, lng: 138.001456},
  zoom: 5
 });
 markers.forEach(function(item){
  buildmarker(item[0], item[1], item[2], item[3], item[4], item[5], geocoder, map);
 });
}

function buildmarker(title, address, url, lat, lng, color, geocoder, map) {
 var content = "<h3><a href='" + url + "'>" + title +  '</a></h3>';
 if(lat && lng){
  var latLng = new google.maps.LatLng( lat, lng, false ) ;
  setupmap(latLng, content, map, title, color);
 }else{
  geocoder.geocode({'address': address}, function(results, status) {
   if (status === 'OK') {
    var latLng = results[0].geometry.location;
    setupmap(latLng, content, map, title, color);
   }
  });
 }
}

function setupmap(latLng, content, map, title, color){
 var infowindow = new google.maps.InfoWindow();
// var image_url = '../wp-content/themes/' + nmc_thema_name + '/assets/img/common/map-point-' + color + '.png';
 var image_url = nmc_assets_dir + '/img/common/map-point-' + color + '.png';
 var marker = new google.maps.Marker({
  title: title,
  map: map,
  position: latLng,
  icon: image_url
 });
 google.maps.event.addListener(marker,'click', (function(marker, content, infowindow){
  return function() {
   infowindow.setContent(content);
   infowindow.open(map,marker);
  };
 })(marker,content,infowindow));
}
